import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { setCsrfToken } from "../api";

const PrivateRoute = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    axios
      .get("/check-session.php")
      .then((res) => {
        if (res.data.loggedIn && res.data.csrfToken) {
          setCsrfToken(res.data.csrfToken);
        }
        if (res.data.loggedIn && res.data.email) {
          localStorage.setItem("userEmail", res.data.email);
        }
        setIsLoggedIn(!!res.data.loggedIn);
        setAuthChecked(true);
      })
      .catch((err) => {
        console.error("Session check failed:", err);
        setAuthChecked(true);
        setIsLoggedIn(false);
      });
  }, []);

  if (!authChecked) {
    return null; // Or a loading spinner
  }

  return isLoggedIn ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
